"use client";

import React from "react";
import { CircleCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const commitments = [{
  title: "Εμπιστευτικότητα",
  description: "Απόλυτη εχεμύθεια στον χειρισμό κάθε υπόθεσης. Προστατεύουμε την καριέρα, την υπόληψη και τα προσωπικά σας δεδομένα με αυστηρά πρωτόκολλα ασφαλείας."
}, {
  title: "Ταχύτητα",
  description: "Άμεση ανταπόκριση και ταχεία διεκπεραίωση των διαδικασιών. Αναγνωρίζουμε την κρισιμότητα του χρόνου στο απαιτητικό περιβάλλον των Ενόπλων Δυνάμεων."
}, {
  title: "Νομική Θωράκιση",
  description: "Πλήρης νομική και συμβουλευτική κάλυψη. Η βαθιά γνώση του στρατιωτικού δικαίου και των κανονισμών διασφαλίζει τα δικαιώματά σας σε κάθε βήμα."
}];
export default function OurCommitment() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="η-δέσμευσή-μας-προς-τον-ένστολο" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div ref={ref} className={`grid grid-cols-1 gap-12 lg:gap-16 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="flex flex-col gap-10 lg:gap-12 items-center text-center">
            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-tight">
              Η Δέσμευσή μας προς τον Ένστολο
            </h2>

            <div className="flex flex-col gap-8">
              {commitments.map((item, i) => <div key={i} data-index={i} className="flex gap-5 items-start">
                  <CircleCheck className="w-7 h-7 text-primary shrink-0 mt-1" />
                  <div className="flex flex-col gap-2">
                    <h3 className="font-default text-2xl font-bold text-foreground">
                      {item.title}
                    </h3>
                    <p className="font-default text-lg text-foreground leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          {}
          
        </div>
      </div>
    </section>;
}